import { Component, ViewChild } from '@angular/core';
import { App, Platform, NavController, LoadingController, ToastController,  Events } from 'ionic-angular';

import { HomePage } from '../pages/home/home';
import { AuthService } from './../providers/auth.service';
import { ApiAuthStore } from './../providers/store/api.auth.store';
import { LicenseKeyService } from './../providers/license-key.service';
import { MaintenanceService } from './../providers/maintenance.service';
import { VersionupService } from './../providers/versionup.service';
import { ContractService } from './../providers/contract.service';

import { PAGES_CONFIG } from './../configs/pages.config';
import { EVENTS_CONFIG } from './../configs/events.config';
import { WebSocketService } from './../providers/web-socket.service';
import { SideMenuService } from './../providers/side.menu.service';
import { UtilService } from '../providers/util.service';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage:any = HomePage;

  app: App;
  // Root以下でNavControllerを利用できるので、ここで利用するためには子Viewからインスタンスを取得するみたいなことをするらしい
  // https://forum.ionicframework.com/t/no-provider-for-navcontroller-error-in-rc4/75846/2
  @ViewChild('content') navCtrl: NavController;

  constructor(
    public platform: Platform,
    public loadingCtrl: LoadingController,
    public toastController: ToastController,
    private events: Events,
    private licenseKeyService: LicenseKeyService,
    public authService: AuthService,
    private apiAuthStore: ApiAuthStore,
    private contractService: ContractService,
    private maintenanceService: MaintenanceService,
    private versionUpService: VersionupService,
    public sideMenuService: SideMenuService,
    private webSocketService: WebSocketService,
    public utilService: UtilService,
  ) {
    platform.ready().then(() => {

      // this.uniqueDeviceID.get().then((uuid: any) => {
      //   this.events.publish(EVENTS_CONFIG.UUID, uuid);
      // }).catch((error: any) => {
      //   let uuid = 'Local_Development';
      //   this.events.publish(EVENTS_CONFIG.UUID, uuid);
      // });
      // ライセンスキー情報
      this.apiAuthStore.getLicenseKey().then((licenseKey) => {
        if (licenseKey) {
          this.events.publish(EVENTS_CONFIG.LICENSE_KEY, licenseKey);
        }
      })
      // Token情報
      this.apiAuthStore.getToken().then((token) => {
        if (token) {
          this.events.publish(EVENTS_CONFIG.TOKEN, token);
        }
      })
      // URL情報
      this.apiAuthStore.getUrl().then((url) => {
        if (url) {
          this.events.publish(EVENTS_CONFIG.API_URL, url);
        }
      })

      // メンテナンス状態変更イベント
      events.subscribe(EVENTS_CONFIG.MAINTENANCE, (maintenanceCode) => {

        this.maintenanceService.setCode(maintenanceCode);

        if (this.maintenanceService.isMode1()) {
          this.changePage(PAGES_CONFIG.MAINTENANCE);
          return;
        }
        if (this.maintenanceService.isMode2()) {
          this.changePage(PAGES_CONFIG.MAINTENANCE);
          return;
        }
      });

      // バージョンアップ状態変更イベント
      events.subscribe(EVENTS_CONFIG.VERSION_UP, (code) => {
        this.versionUpService.setCode(code);
        if (this.versionUpService.isMode2()) {
          this.changePage(PAGES_CONFIG.VERSIONUP);
          return;
        }
      });

      // URLに ?licenseKey=xxxx があれば、そのライセンスキーを取得してライセンスキー入力画面に遷移する
      // なければ、Storeからライセンスキーを取得して認証を試みる
      const licenseKeyFromUrl = this.getLicenseKeyFromUrl();
      if (licenseKeyFromUrl) {
        this.authService.initLogout().then(() => {
          this.changePage(PAGES_CONFIG.LICENSE_KEY, { licenseKey: licenseKeyFromUrl });
        });
      } else {
        // Storeからアプリの基本情報を取得
        this.licenseKeyService.getLicenseKey().then(() => {
          // ライセンスキーチェック
          if (this.licenseKeyService.hasLicenseKey) {
            this.contractService.setContract().then(() => {
              // 認証済みかチェック
              this.authService.verify();
            })
            return;
          }
          this.changePage(PAGES_CONFIG.LICENSE_KEY);
        });
      }
    });


    events.subscribe(EVENTS_CONFIG.SET_ROOT, (pageName) => {
      this.changePage(pageName)
    })

    // ログアウト関連
    events.subscribe(EVENTS_CONFIG.LOGOUT, () => {
      this.authService.logout();
    });

    // 強制ログアウト関連
    events.subscribe(EVENTS_CONFIG.INITLOGOUT, () => {
      this.authService.initLogout();
    });

    // ユーザのログイン成功時の処理
    events.subscribe(EVENTS_CONFIG.LOGIN, (user) => {
      // TODO: 一旦暫定で組み込み
      if (user && user.menuType === 'SOMPO_MENU') {
        this.webSocketService.connect();
      }
    });

  }

  changePage(pageName, params = {}) {
    this.navCtrl.setRoot(pageName, params);
  }

  /**
   * ログアウト処理
   * @return boid
   */
  logout(): void {
    let loading = this.loadingCtrl.create({
      content: 'ログアウト中...'
    });
    loading.present();
    this.authService.logout().then(() => {
      loading.dismiss();
    });
    // ログアウトする場合は、メニューリストを空にする
    this.sideMenuService.setShowMenuList('');
  }

  clearCache(): void {

    if (!confirm("アプリケーションを最新の\nバージョンに更新します。\n10秒程度、端末を操作せずに\nお待ち下さい。")) return ;

    let loading = this.loadingCtrl.create({
      content: '再読み込み中...'
    });
    loading.present();
    (<any>window).location = '/?clear_cache='+new Date().getTime()
  }

  getLicenseKeyFromUrl(): string | null {
    const [base, path] = window.location.href.split('/#/');
    const urlParams = new URLSearchParams(new URL(`${base}/${path}`).search);
    return urlParams.get('licenseKey');
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts